export const ResponseMessages = {
	errorUserAlreadyDeleted: "The user is already deleted",
	errorUserDeleted: "Profile is deleted. Please contact admin",
	errorLinkExpired: "The link has expired",
	errorNotAuthorized: "Not authorized", // Your are not authorized
	notAuthorizedToViewProfile : "You are not authorized to view this profile",
	errorInput: "Please check your Inputs",
	errorEmail: "Please enter a valid email address", //Please enter your email in the format yourname@example.com
	errorEmailDontExist: "Email dont exist",
	errorUserNonMember: "User is not a member of the selected community",
	errorName: "Name must be min 1 and max 100 character",
	errorUserHandle: "Invalid User Handle",
	errorName50: "Name needs to be atleast 50",
	errorPassword: "Password didn't match", //
	errorPasswordMismatch: "Password didn't match", //Passwords are not matching. Please recheck and continue.
	errorPasswordEnterValid: "Please enter a valid password",
	errorNewPasswordEnterValid: "Please enter a valid new password",
	errorCurrentPasswordMisatch: "Current password didn't match",
	errorSamePassword: "Same password cannot be used to change password",
	errorPasswordInvalid: "Please enter a valid password", //[passwordRules, "Your password should contain:</br> 1. at least 1 uppercase. [A-Z]</br> 2. at least 1 lowercase. [a-z]</br> 3. at least 1 special character. [!@#$%^&*()-_=+{};:,<.>] </br>4. at least 1 number. [0-9] </br> 5. has `the length of minimum 8 characters"],
	// [isGreaterThan(7), 'Minimum length of 8 is required'] //make sure the points are in next line arranged in asceding order
	errorCommunityId: "Invalid Community ID",
	errorAllowAvailableCommunities: "onlyAvailableToPost should be boolean value",
	errorConnectionRequestId: "Invalid ConnectionId",
	errorRequestId: "Invalid requestedId",
	errorConnectionId: "Invalid ConnectionId",
	errorAccessToken: "Invalid Access Token",
	errorInTransaction: "Oops! We can not process your request now. Please try again later!",
	errorUserId: "Invalid User ID",
	errorPostId: "Invalid Post ID",
	errorPostTimeStamp: "Invalid timeStamp",
	errorCommunityToken: "Invalid Community Token",
	errorInviteToken: "Invalid Invite Token",
	errorUnexpected: "Some Unexpected Error",
	errorForgotPassword: "Verify email before resetting password",
	errorCommunityTag: "Affiliated Tag is missing",
	errorModelStatus: "Please verify your account. Check you email.",
	errorFile404: "File not attached",
	errorHiddenCommunity: "You cant request to join a hidden Community",
	errorUserAlreadyPartOfCommunity: " User is already part of Community", //Member is already part of the community 
	errorCommunityNotAccepted: "Your Community is still not Accepted!", //Your community approval is pending
	errorDataNotFound: "No data found",
	errorOwnerCannotLeaveCommunity: "The owner must transfer ownership before leaving this community/space",
	errorUserAlreadyExist: "This email address is already registered",
	errorUserExists: "This email is already registered. Please sign in to continue",
	errorAffiliatedTag: "Please specify an affiliation tag",
	errorLoginNewUser: "This email is not registered. Please request an invitation to join",
	erroVerifyMail: "This email has already been verified",
	errorSlugAlreadyExists: "This URL identifier is already in use",
	errorTokenId: "Invalid token identifier",
	errorUserDontExist: "User dont exist",

	errorTextField: "Text content is required for text posts",
	errorImageField: "Images are required for photo posts",
	errorFileField: "File attachment is required for file posts",
	errorVideoLinkField: "Video link is required for video posts",
	errorUrlField: "URL is required for article posts",
	errorPostType: "Invalid post type. Please select from: Article (1), Post (2), Photo (3), Video (4)",

	errorMessageGroup: "A group already exists for these users",
	errorUserExist: "This user already exists",
	errorP2P: "This is a private conversation",
	errorCalendlyUrl: "Invalid Calendly URL",

	errorEventId: "Invalid event identifier",
	errorEventTitle: "Invalid event title",
	errorEventDescription: "Invalid event description",
	errorEventStartTime: "Invalid start time",
	errorEventEndTime: "Invalid end time",
	errorEventReoccuringTime: "Invalid recurring time",
	errorJodId: "Invalid job identifier",
	errorJobOwner: "Job creators cannot apply to their own listings",
	errorJobAlreadyApplied: "You have already applied for this position",

	errorPostDeleted: "This post has been deleted",
	errorPostText: "Invalid post content",
	errorPostUrl: "Invalid post URL",
	errorPostLocation: "Invalid post location",
	errorPostDelete: "You have not liked this post",
	errorNoRegisteredMobile: "No registered device found",
	errorOpportunityType: "Invalid opportunity type",
	errorAnswerNotLiked: "You have not liked this answer",
	errorUnfollowQuestion: "You are not following this question",
	errorUnfollowQuestionAnswer: "You are not following this answer",
	errorfollowQuestionAlready: "You are already following this question",
	errorfollowQuestioAnswerAlready: "You are already following this answer",
	errorCommentLiked: "You have already liked this comment",
	errorCommentNotLiked: "You have not liked this comment",
	errorProfilePrivate: "This profile is private",
	errorComuunityHidden: "This community is private",
	errorUserSetting: "Error updating user settings",
	errorAlreadySentRequest: "You have already requested to join this community",
	errorPasswordUsedEarlier: "You cannot reuse any of your last three passwords",
	errorUserInvite: "Invitation has been sent",
	errorMorderatorExist: "This user is already a moderator",
	errorMediaCenterId: "Invalid media center identifier",
	errorMediaCenterParentId: "Invalid parent folder",
	errorNoMediaFound: "No media found",
	errorValShareMCfileTitle: "Invalid caption",

	errorChildCommunityParent: "Parent community reference is not needed here",
	errorUserLimit: "User limit has been reached",

	errorCantRemoveTag: "Please remove all users from this tag before removing it from the community",
	errorNoneditableAnswer: "This answer cannot be modified",
	errorUnableFetchMeta: "Unable to retrieve metadata from URL",
	successCommentAlreadyLikes: "You have already liked this comment",
	successPostCommentLikes: "Comment liked successfully",

	success: "Operation completed successfully",
	successUserFollow: "User followed successfully",
	successUserUnfollow: "User unfollowed successfully",
	errorUserFollowSelf: "You cannot follow yourself",
	errorUserAlreadyFollowing: "You are already following this user",
	errorUserNotFollowing: "You are not following this user",
	successEmailVerified: "Email verified successfully",
	successPasswordReset: "Password has been updated successfully",
	succesEmailVerificationMail: "Verification email has been sent",

	successAnswerLikedAlready: "You have already liked this answer",
	successMorderatorPostDelete: "Post has been deleted by moderator",
	successMorderatorPostUnDelete: "Post has been restored by moderator",
	successMorderatorServiceDelete: "Service has been deleted by moderator",
	successMorderatorJobDelete: "Job has been deleted by moderator",
	successMorderatorEventDelete: "Event has been deleted by moderator",
	successMorderatorFundraisingDelete: "Fundraising has been deleted by moderator",
	successMorderatorQuestionDelete: "Question has been deleted by moderator",
	successMorderatorUserPrivilegesRevoked: "User privileges have been revoked",
	successMorderatorUserInviteSent: "User invitation has been sent",
	successMorderatorPostDecline: "Post has been declined by moderator",

	communityClassificationUpdate: "Community classification has been updated",

	customRequestSent: "Your request has been submitted",
	customJoinedPublicCommunity: "You have successfully joined the public community",

	successUserRegistration1: "Registration completed successfully",

	successPostCreate: "Post created successfully",
	successPostCommentCreate: "Comment added successfully",
	successPostLike: "Post liked successfully",
	successPostAlreadyLiked: "You have already liked this post",
	successPostShared: "Post shared successfully",
	successPostLikeDelete: "Post like removed successfully",
	successPostDelete: "Post deleted successfully",
	successPostCommentDelete: "Comment deleted successfully",
	successPostReportCreated: "Post reported successfully",
	successPostAlreadyReported: "You have already reported this post",
	successPostCommentReportCreated: "Comment reported successfully",
	successCommentAlreadyReported: "You have already reported this comment",
	successCommunityCreated: "Community created successfully",

	successUserHide: "User profile has been hidden",
	successUserUnHide: "User profile has been unhidden",
	successUserHiddenAlready: "User profile is already hidden",

	successEventDelete: "Event deleted successfully",
	successFundingDelete: "Funding deleted successfully",
	successJobDelete: "Job deleted successfully",
	successEmailSent: "Email sent successfully",

	updateCommunityStatusMessage: "Community status has been updated",

	successQuestionDeleted: "Question deleted successfully",
	SuccessQuestionFollow: "Question followed successfully",
	SuccessQuestionUnfollow: "Question unfollowed successfully",
	SuccessQuestionAnswerFollow: "Answer followed successfully",
	SuccessQuestionAnswerUnFollow: "Answer unfollowed successfully",
	successAnswerDelete: "Answer deleted successfully",
	successCommentDelete: "Comment deleted successfully",
	successCommentUpdate: "Comment updated successfully",

	successServiceCreated: "Service created successfully",
	successServiceDelete: "Service deleted successfully",

	successFundRaisingUpdate: "Fundraising updated successfully",
	successFundRaisingDeleted: "Fundraising deleted successfully",
	successNewsletterDeleted: "Newsletter deleted successfully",
	successNewsletterUpdated: "Newsletter updated successfully",

	errorMessageField: "Either a message or media content is required",

	//-------------------------------------------------------------------------------
	//Platform Admin error messages

	//error messages
	notPlatformAdmin: "You do not have platform administrator privileges",

	uploadErrorName: "Name is required and must be at least 3 characters",
	uploadErrorImageID: "Invalid image identifier",
	uploadErrorIndustryID: "Invalid feature identifier",


	communityUploadErrorSize: "Size must be a number",
	communityUploadErrorLayer: "Layer must be a number",
	communityUploadErrorClassification: "Classification IDs must be comma-separated",
	communityUploadErrorClassificationID: "Invalid classification identifier",
	communityUploadErrorSpeciality: "Specialty IDs must be comma-separated",
	communityUploadErrorSpecialityID: "Invalid specialty identifier",
	communityUploadErrorFeature: "Feature IDs must be comma-separated",
	communityUploadErrorFeatureID: "Invalid feature identifier",
	communityUploadErrorTag: "Tag IDs must be comma-separated",
	communityUploadErrorTagID: "Invalid tag identifier",
	communityUploadErrorFeatureImageID: "Invalid banner image identifier",

	userUploadErrorEmail: "Email is required",
	userUploadErrorIsAdmin: "Admin status must be specified as a boolean value",
	userUploadErrorIsAdminFlag: "Admin flag must be a boolean value (0 or 1)",
	userUploadErrorCommunity: "Community IDs must be comma-separated",
	userUploadErrorCommunityID: "Invalid community identifier",
	userUploadErrorOnboarBoardCommunity: "Invalid onboarding community identifier",
	userUploadErrorPrimaryCompanyID: "Invalid primary company identifier",
	userUploadErrorResumeID: "Invalid resume file identifier",
	userUploadErrorExpertise: "Expertise IDs must be comma-separated",
	userUploadErrorExpertiseID: "Invalid expertise identifier",
	userUploadErrorTag: "Affiliation tag is required",
	userUploadErrorTagID: "Invalid affiliation tag identifier",

	uploadErrorTitle: "Title is required",
	uploadErrorCompany: "Company name is required",
	uploadErrorCommunityName: "Community name is required",
	uploadErrorCommunityID: "Community identifier is required",
	uploadErrorLocation: "Location is required",
	uploadErrorStartTime: "Start time is required",
	uploadErrorEndTime: "End time is required",
	uploadErrorMedia: "Media content is required",
	uploadErrorEmailNotFound: "Email not found in database",

	uploadErrorDegree: "Degree is required",
	uploadErrorFieldOfStudy: "Field of study is required",

	uploadErrorExpertise: "Expertise must be at least 3 characters",
	uploadErrorIndustry: "Industry must be at least 3 characters",
	//success messages
	successUpload: "Data uploaded successfully",

	errorIndustryId: "Invalid industry identifier",

	//-------------------------------------------------------------------------------
	colourCommunitySet: "Community color has been updated",

	adminApproval: "Request approved successfully",
	adminRejection: "Request rejected successfully",
	bodyValidationError: "Request body cannot be empty",
	errorUserAlreadyNominate: "This user has already been nominated",
	errorAnalyticsScreen: "Screen not found",
	faqSupportResponse: "We will respond to your inquiry shortly",
	communityDeclineRequest: "Community request has been rejected",

	//---------------------------------------------------------------------------
	//Plugin responses

	errorCommunityAlreadyAdded: "This plugin is already installed",
	errorCommunityPluginNotAdded: "This plugin is not installed",
	errorInvalidPluginId: "Invalid plugin identifier",

	//------------------------------------------------------------------------------

	userAdded: "User added successfully",
	userRemoved: "User removed",
	groupLogoChanged: "Group logo changed",
	groupNameChanged: "Group name changed",
	groupNameLogoChanged: "Group name and logo changed",
	groupCategoryExists: "Category already exists",
	invalidCategoryId: "Invalid category id",
	groupCategoryNotcannected: "Category is not connected to mattermost",
	userAlreadyAdmin: "User is already admin",
	userAlreadyMember: "User is already a member",
	invalidGroupId: "Invalid group id",
	//-------------------------------------------------------------------------------

	errorPollId: "Invalid Poll ID",
	errorPollPutRequest: "any one field is required for edit",
	errorPollAlreadySubmit: "User has already submitted for this poll",
	errorPollSubmitAfterEnd: "Poll time has ended",
	errorPollNotCreator: "User should be the creator of poll to end",
	errorPollAlreadyEnded: "Poll already ended",
	errorEndPollDownload: "Poll has to end for download",

	errorSurveyId: "Invalid Survey ID",
	errorSurveyPutRequest: "any one field is required for edit",
	errorSurveyAlreadySubmit: "User has already submitted for this survey",
	errorSurveyQuestionLimitExceed: "Maximum limit of questions reached, 10",
	errorSurveyNotCreator: "User should be the creator of survey to end",
	errorSurveySubmitAfterEnd: "Survey time has ended",
	errorSurveyAlreadyEnded: "Survey already ended",
	errorSurveyPollDownload: "Survey has to end for download",

	//-----------------------------------------------------------------------------------

	errorFileExtention: "Unsupported file extention",

	//-----------------------------------------------------------------------------------

	errorEventRoleNotFound: "User role is required",
	errorEventClosed: "This ApiType is closed",
	errorEventLocation: "Event location is required",
	errorEventNotDraft: "Only a draft event can be published",
	errorEventIncomplete: "Add a name, a start time and an end time before publishing this event",
	errorEventPublishOwner: "Only the event creator can publish this event",

	//-----------------------------------------------------------------------------------
	successInvitationLinkCreate: "Invitation Link Created Successfully",
	successInvitationLinkUpdate: "Invitation Link updated Successfully",

	errorInvitationIdNotFound: "Invitation Link is Not Found",
	errorInvitationToken: "Invalid Invitation Token",
	errorInvitationRole: "User Role is not available",
	errorInvitationFirebaseShortLink: "Firebase Short Link Creation Error",
	errorInvitationUpdateUserLimit: "The user limit for this invite link can not be reduced, as it has already been exceeded",

	//----------------------------------------------------------------------------------
	internalServerError: "Internal Server Error",
	nonRenamableFeature: "This Feature can't be renamed ",
	tagAlreadyExist: "Tag already exist ",
	customListAlreadyExist: "Custom List with this name already exists",
	errorCustomListId: "Invalid Custom List Id ",
	selectOrAddTag: "Please select or add a tag ",
	invalidCustomListId: "Invalid Custom List Id ",
	customListNotFound: "Custom list not found",
	customListDuplicateName: "Custom list with this name already exist",

	//----------------------------------------------------------------------------------
	errorSharePermission: "You Do Not Have Permission To Share the POST To Selected Community",
	errorShareFeature: "This feature is not enabled for the selected community.",
	communityIdOrReadableIdRequired: "Please add valid community or readable id identifier",

	// Pagination 
	paginationStartMissing: "Please provide a valid start index for pagination",
	paginationCountMissing: "Please specify the number of items to display per page",
	errorEventFilterType: "Invalid filter type. Please select from: All (0), Going (1), Interested (2), HappeningNow (3), hosting (4), Hosted (5)",
	errorEventApiType: "Invalid API type. Please select from: UpcomingEvents (0), PastEvents (1)",
	errorEventFormatType: "Invalid event format type. Please select from: Huddle (0), Webinar (1), External Link (2)",
	errorEventType: "Invalid event type. Please select from: Virtual (0), InPerson (1), Hybrid (2)",

	//External Vendor ---------------------------------------------------------------
	activeTokenAlreadyExists: "An active API key already exists for this community to create a new API key, please delete the existing one first.",
	keyExpired: "The provided X-API-KEY is invalid or has expired.",
	tooManyRequests: 'Too Many Requests',

	// External Vendor Webhook Subscription
	alreadyExitingWebhookSubscription: "Webhook subscription already exists for this community.",
	webhookVerificationSuccess: "Webhook URL verification successful.",
	webhookVerificationFailed: "Webhook URL verification failed.",
	webhookSubscriptionUpdated: "Webhook subscription updated successfully.",
	noActiveWebhookSubscription: "No active webhook subscription found for this community.",

	// Stripe
	locationIsRequired: 'Location is required',
	userIdIsRequired: 'User ID is required',

	// Offers
	errorOfferNotFound: "Offer not found",
	errorOfferContentNotPurchased: "This content is attached to an offer. To see the content, please buy the offer.",
	errorOfferNameRequired: "An offer name is required",
	errorOfferSlugTaken: "This URL slug is already in use",
	errorOfferSlugRequired: "Please enter a product page URL slug.",
	errorOfferFeatureNotEnabled: "Offers are not enabled for this community",
	errorOfferMonetizationNotEnabled: "Stripe monetization must be enabled to use paid offers",
	errorOfferUsePaidCheckout: "This is a paid offer — use the checkout endpoint",
	errorOfferUseFreeClaimEndpoint: "This is a free offer — use the claim endpoint",
	errorOfferAlreadyPurchased: "You have already purchased this offer",
	errorOfferAlreadyClaimed: "You have already claimed this offer",
	errorOfferNoSeatsAvailable: "No seats are available for this offer",
	errorOfferReviewRequiresPurchase: "You must purchase an offer before leaving a review",
	errorOfferReviewStarsInvalid: "Rating must be between 1 and 5 stars",
	successOfferPurchased: "Offer purchased successfully",
	successOfferClaimed: "Offer claimed successfully",
	successOfferDeleted: "Offer deleted successfully",
	errorPaidJoinRequired: "This community requires a paid plan to join",
	errorPlanNotSold: "This plan is not available for joining",
	errorSkipCreditCardNeedsFreeOrTrial: "Skip credit card only works when every price is free or starts with a trial",
	errorCardRequiredForPrice: "This plan needs a card to join",
	errorStripeNotReadyForPaidJoin: "Connect Stripe and finish verification before making joining paid",
};


export const ResponseMessageTranlation = (t, req = null) => ({
	errorPassword: t(req, "responseMessage.errorPassword", ResponseMessages.errorPassword),
	errorPasswordMismatch: t(req, "responseMessage.errorPasswordMismatch", ResponseMessages.errorPasswordMismatch),
	errorPasswordEnterValid: t(req, "responseMessage.errorPasswordEnterValid", ResponseMessages.errorPasswordEnterValid),
	errorLoginNewUser: t(req, "responseMessage.errorLoginNewUser", ResponseMessages.errorLoginNewUser),
	customListAlreadyExist: t(req, "responseMessage.customListAlreadyExist", ResponseMessages.customListAlreadyExist),
	invalidCustomListId: t(req, "responseMessage.invalidCustomListId", ResponseMessages.invalidCustomListId),
	customListNotFound: t(req, "responseMessage.customListNotFound", ResponseMessages.customListNotFound),
	customListDuplicateName: t(req, "responseMessage.customListDuplicateName", ResponseMessages.customListDuplicateName),
	communityIdOrReadableIdRequired: t(req, "responseMessage.communityIdOrReadableIdRequired", ResponseMessages.communityIdOrReadableIdRequired),
	notAuthorizedToViewProfile: t(req, "responseMessage.notAuthorizedToViewProfile", ResponseMessages.notAuthorizedToViewProfile),
	userIdIsRequired: t(req, "responseMessage.userIdIsRequired", ResponseMessages.userIdIsRequired),
	errorOfferNotFound: t(req, "responseMessage.errorOfferNotFound", ResponseMessages.errorOfferNotFound),
	errorOfferContentNotPurchased: t(req, "responseMessage.errorOfferContentNotPurchased", ResponseMessages.errorOfferContentNotPurchased),
	errorOfferNameRequired: t(req, "responseMessage.errorOfferNameRequired", ResponseMessages.errorOfferNameRequired),
	errorOfferSlugTaken: t(req, "responseMessage.errorOfferSlugTaken", ResponseMessages.errorOfferSlugTaken),
	errorOfferSlugRequired: t(req, "responseMessage.errorOfferSlugRequired", ResponseMessages.errorOfferSlugRequired),
	errorOfferFeatureNotEnabled: t(req, "responseMessage.errorOfferFeatureNotEnabled", ResponseMessages.errorOfferFeatureNotEnabled),
	errorOfferMonetizationNotEnabled: t(req, "responseMessage.errorOfferMonetizationNotEnabled", ResponseMessages.errorOfferMonetizationNotEnabled),
	errorOfferUsePaidCheckout: t(req, "responseMessage.errorOfferUsePaidCheckout", ResponseMessages.errorOfferUsePaidCheckout),
	errorOfferUseFreeClaimEndpoint: t(req, "responseMessage.errorOfferUseFreeClaimEndpoint", ResponseMessages.errorOfferUseFreeClaimEndpoint),
	errorOfferAlreadyPurchased: t(req, "responseMessage.errorOfferAlreadyPurchased", ResponseMessages.errorOfferAlreadyPurchased),
	errorOfferAlreadyClaimed: t(req, "responseMessage.errorOfferAlreadyClaimed", ResponseMessages.errorOfferAlreadyClaimed),
	errorOfferNoSeatsAvailable: t(req, "responseMessage.errorOfferNoSeatsAvailable", ResponseMessages.errorOfferNoSeatsAvailable),
	errorOfferReviewRequiresPurchase: t(req, "responseMessage.errorOfferReviewRequiresPurchase", ResponseMessages.errorOfferReviewRequiresPurchase),
	errorOfferReviewStarsInvalid: t(req, "responseMessage.errorOfferReviewStarsInvalid", ResponseMessages.errorOfferReviewStarsInvalid),
	successOfferPurchased: t(req, "responseMessage.successOfferPurchased", ResponseMessages.successOfferPurchased),
	successOfferClaimed: t(req, "responseMessage.successOfferClaimed", ResponseMessages.successOfferClaimed),
	successOfferDeleted: t(req, "responseMessage.successOfferDeleted", ResponseMessages.successOfferDeleted),
	errorPaidJoinRequired: t(req, "responseMessage.errorPaidJoinRequired", ResponseMessages.errorPaidJoinRequired),
	errorPlanNotSold: t(req, "responseMessage.errorPlanNotSold", ResponseMessages.errorPlanNotSold),
	errorSkipCreditCardNeedsFreeOrTrial: t(req, "responseMessage.errorSkipCreditCardNeedsFreeOrTrial", ResponseMessages.errorSkipCreditCardNeedsFreeOrTrial),
	errorCardRequiredForPrice: t(req, "responseMessage.errorCardRequiredForPrice", ResponseMessages.errorCardRequiredForPrice),
	errorStripeNotReadyForPaidJoin: t(req, "responseMessage.errorStripeNotReadyForPaidJoin", ResponseMessages.errorStripeNotReadyForPaidJoin),
})
